// removed by extract-text-webpack-plugin
module.exports = {"center-content":"index__center-content__FPQnb"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 101
// module chunks = 0